import React from 'react';
import PropTypes from 'prop-types';
import NavActions from '../../actions';
import SearchExtension from './SearchExtension';

export default class Search extends React.PureComponent {
    static propTypes = {
        isActive: PropTypes.bool,
        onSearch: PropTypes.func,
        searchMaxWidth: PropTypes.number
    };

    static contextTypes = {
        messages: PropTypes.object,
        isMobile: PropTypes.bool
    };

    showSearch = (e) => {
        e.preventDefault();
        if (!this.props.isActive) {
            NavActions.searchActive(true);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.searchActive(false);
            if (this.context.isMobile) {
                NavActions.mobileNavActiveLinks(true);
            }
        }

        //Reset all other clickable items
        NavActions.tabletNavActive(false);
        NavActions.mobileLocaleActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.mobileUserActive(false);
    };

    render() {
        const messages = this.context.messages || {};
        const isActive = this.props.isActive;
        const desktopOrTabletActive = isActive && !this.context.isMobile;
        return (
            <div
                id="search"
                className="no-before">
                {!this.context.isMobile ?
                    <SearchExtension
                        active={isActive}
                        onSearch={this.props.onSearch}
                        hideSearch={this.showSearch}
                        searchMaxWidth={this.props.searchMaxWidth} /> : ''}

                <div
                    id="searchIcon"
                    className={`bg-color ${desktopOrTabletActive ? 'no-before' : 'accent-bg-color-before'} ${isActive ? 'active' : ''}`}>
                    <a
                        role="button"
                        tabIndex="0"
                        onClick={this.showSearch}
                        title={messages.search}
                        className="text-color-hover">
                        <i className={`eg-header-icon-search ${this.context.isMobile && isActive ? 'hidden' : ''}`} />
                        <i className={`eg-header-icon-close ${this.context.isMobile && !isActive ? 'hidden' : ''}`} />
                    </a>
                </div>
            </div>
        );
    }
}
